import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { StartToModalTile } from '@components/molecules/StartToModalTile/StartToModalTile';
import {
    MobileModal,
    MobileModalProps,
} from '@components/organisms/MobileModal/MobileModal';

import { useUserModules } from '@utils/hooks/useUserModules';

import { getPath } from '@services/RouteService/paths';

import {
    StartToModalInner,
    StartToModalTitle,
} from './MobileStartToModal.styled';

export const MobileStartToModal = ({
    onClose,
    open,
}: Pick<MobileModalProps, 'onClose' | 'open'>) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { data } = useUserModules();
    const modules = data?.user.tenant?.modules;

    return (
        <MobileModal footer onClose={onClose} open={open} topPadding={18}>
            <MobileModal.Container>
                <StartToModalTitle>{t('START_TO')}</StartToModalTitle>
                <StartToModalInner>
                    <StartToModalTile
                        description={t('TELL_WHAT_YOU_WITNESSED')}
                        icon="Svg2DMessaging24"
                        onClick={() => {
                            navigate(getPath({ path: '/new-conversation' }));
                        }}
                        testId="IC7MfVV"
                        title={t('MAKE_REPORT')}
                    />
                    {modules?.surveys && (
                        <StartToModalTile
                            description={t('PARTICIPATE_AND_LET_US_KNOW')}
                            icon="Svg2DSurvey24"
                            onClick={() => {
                                navigate(getPath({ path: '/survey/list' }));
                            }}
                            testId="kx96Nu3"
                            title={t('PARTICIPATE_IN_SURVEY')}
                        />
                    )}
                    {modules?.disclosures && (
                        <StartToModalTile
                            description={t('SOMETHING_TO_DECLARE')}
                            icon="Svg2DDAndD24"
                            onClick={() => {
                                navigate(getPath({ path: '/disclosure/list' }));
                            }}
                            testId="spL0eoI"
                            title={t('DECLARE_OR_DISCLOSE')}
                        />
                    )}
                </StartToModalInner>
            </MobileModal.Container>
        </MobileModal>
    );
};
